import { useState, useRef } from "react";
import Back from "@/components/specific/Back";
import Button from "@/components/common/Button";
import ChangePassword from "@/pages/settings/components/general_settings/Change_Password";
import ManageAccount from "@/pages/settings/components/general_settings/Manage_Account";

const GeneralSettings = () => {
  const [activeTab, setActiveTab] = useState("account"); // 'account' or 'password'
  const [profileImage, setProfileImage] = useState(null);

  // Add refs for child components
  const manageAccountRef = useRef();
  const changePasswordRef = useRef();

  const handleProfileImageChange = (file) => {
    setProfileImage(file);
  };

  const handleUpdate = async () => {
    switch (activeTab) {
      case "account":
        if (manageAccountRef.current) {
          await manageAccountRef.current.handleSubmit();
        }
        break;
      case "password":
        if (changePasswordRef.current) {
          await changePasswordRef.current.handleSubmit();
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className="text-left">
      <div className="mb-3">
        <Back text="Back" />
      </div>
      <h1 className="mb-2 heading-large text-lighterGrey">General Settings</h1>

      <div className="flex items-center justify-between">
        <div className="flex gap-2">
          <Button
            text="Manage Account"
            customBgColor={activeTab === "account" ? "primary" : "white"}
            customTextColor={activeTab === "account" ? "white" : "primary"}
            className="w-[140px] h-[37px] text-xs border border-primary whitespace-nowrap"
            onClick={() => setActiveTab("account")}
          />
          <Button
            text="Manage Password"
            customBgColor={activeTab === "password" ? "primary" : "white"}
            customTextColor={activeTab === "password" ? "white" : "primary"}
            className="w-[140px] h-[37px] text-xs whitespace-nowrap border border-primary"
            onClick={() => setActiveTab("password")}
          />
        </div>
        <Button
          text={activeTab === "password" ? "Update Password" : "Update Info"}
          customTextColor="white"
          customBgColor="primary"
          className="w-[111px] h-[37px] text-small-xs whitespace-nowrap hidden lg:flex"
          onClick={handleUpdate}
        />
      </div>

      {activeTab === "account" ? (
        <ManageAccount
          ref={manageAccountRef}
          profileImage={profileImage}
          onProfileImageChange={handleProfileImageChange}
        />
      ) : (
        <ChangePassword ref={changePasswordRef} />
      )}

      {/* Mobile update button - shown only on mobile */}
      <Button
        text={activeTab === "password" ? "Update Password" : "Update Info"}
        customTextColor="white"
        customBgColor="primary"
        className="w-full text-xs lg:hidden mt-6"
        onClick={handleUpdate}
      />
    </div>
  );
};

GeneralSettings.displayName = "GeneralSettings";

export default GeneralSettings;
